<template>
  <div>
    <Header></Header>
    <v-container fluid grid-list-md text-xs-center class="margin-top-40px">
      <v-layout row wrap class="pt-4">
        <v-flex xs12 xl4 lg4 md4 sm12>
          <v-card class="mx-auto" color="#E91E63" dark max-width="400">
            <v-card-title>
              <v-icon large left>mdi-twitter</v-icon>
              <span class="title font-weight-light">داورها</span>
            </v-card-title>
            <v-layout row wrap>
              <v-flex xs6>
                <v-card-text
                  class="headline font-weight-bold text-xs-center loain-size-font"
                >{{ refereeCapacity }} %</v-card-text>
              </v-flex>
              <v-flex xs6>
                <div class="text-xs-center">
                  <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="10"
                    :value="refereeCapacity"
                    color="white"
                  >{{ refereeCapacity }}</v-progress-circular>
                </div>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-list-tile class="grow">
                <v-list-tile-avatar color="white">
                  <v-img
                    class="elevation-6"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                  ></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>Evan You</v-list-tile-title>
                </v-list-tile-content>

                <v-layout align-center justify-end>
                  <v-icon class="mr-1">mdi-heart</v-icon>
                  <span class="subheading mr-2">{{capacity}}</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">mdi-share-variant</v-icon>
                  <span class="subheading"></span>
                </v-layout>
              </v-list-tile>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 xl4 lg4 md4 sm12>
          <v-card class="mx-auto" color="#3F51B5" dark max-width="400">
            <v-card-title>
              <v-icon large left>mdi-twitter</v-icon>
              <span class="title font-weight-light">نماینده ها</span>
            </v-card-title>

            <v-layout row>
              <v-flex xs6>
                <v-card-text
                  class="headline font-weight-bold text-xs-center loain-size-font"
                >{{ agentCapacity }} %</v-card-text>
              </v-flex>
              <v-flex xs6>
                <div class="text-xs-center">
                  <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="10"
                    :value="agentCapacity"
                    color="white"
                  >{{ agentCapacity }}</v-progress-circular>
                </div>
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-list-tile class="grow">
                <v-list-tile-avatar color="white">
                  <v-img
                    class="elevation-6"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                  ></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>Evan You</v-list-tile-title>
                </v-list-tile-content>

                <v-layout align-center justify-end>
                  <v-icon class="mr-1">mdi-heart</v-icon>
                  <span class="subheading mr-2">{{capacity}}</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">mdi-share-variant</v-icon>
                  <span class="subheading"></span>
                </v-layout>
              </v-list-tile>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 xl4 lg4 md4 sm12>
          <v-card class="mx-auto" color="#00C853" dark max-width="400">
            <v-card-title>
              <v-icon large left>mdi-twitter</v-icon>
              <span class="title font-weight-light">مسابقه دهندگان</span>
            </v-card-title>

            <v-layout row>
              <v-flex xs6>
                <v-card-text
                  class="headline font-weight-bold text-xs-center loain-size-font"
                >{{ racerCapacity }} %</v-card-text>
              </v-flex>
              <v-flex xs6>
                <div class="text-xs-center">
                  <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="10"
                    :value="racerCapacity"
                    color="white"
                  >{{ racerCapacity }}</v-progress-circular>
                </div>
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-list-tile class="grow">
                <v-list-tile-avatar color="white">
                  <v-img
                    class="elevation-6"
                    src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                  ></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>Evan You</v-list-tile-title>
                </v-list-tile-content>

                <v-layout align-center justify-end>
                  <v-icon class="mr-1">mdi-heart</v-icon>
                  <span class="subheading mr-2">{{capacity}}</span>
                  <span class="mr-1">·</span>
                  <v-icon class="mr-1">mdi-share-variant</v-icon>
                  <span class="subheading">{{raminingCapacity}}</span>
                </v-layout>
              </v-list-tile>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xl6 lg6 md12 sm12 xs12>
          <v-card class="ma-4">
            <v-toolbar color="cyan" dark>
              <v-toolbar-side-icon class="ml-2"></v-toolbar-side-icon>

              <v-toolbar-title style="font-size: 17px;">نمودار</v-toolbar-title>

              <!-- <v-spacer></v-spacer>
        
                  <v-btn icon>
                    <v-icon>search</v-icon>
              </v-btn>-->
            </v-toolbar>

            <div id="chart" class="chartstyle"></div>
          </v-card>
        </v-flex>
        <v-flex xl6 lg6 md12 sm12 xs12 pa-4>
          <v-card>
            <v-toolbar color="#E91E63" dark>
              <v-toolbar-side-icon class="ml-2"></v-toolbar-side-icon>

              <v-toolbar-title class="text-xs-center" style="font-size: 17px;">نمایندگان فروش</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon v-if="agentCapacity <= 100" :to="{name:'agent' }">
                <v-icon>add_circle</v-icon>
              </v-btn>
            </v-toolbar>

            <v-list subheader style="overflow-y: scroll; max-height: 390px;">
              <v-subheader>لیست مدیران فعال و غیر فعال</v-subheader>
              <v-list-tile v-for="item in agentList" :key="item.title" avatar>
                <v-list-tile-avatar>
                  <img :src="item.avatar" />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title class="text-xs-right" v-html="item.title"></v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <div>
                    <v-icon color="primary">create</v-icon>
                    <v-icon :color="item.active ? 'green' : 'red'">fiber_manual_record</v-icon>
                  </div>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Header from "@/components/dashboard/Header";

export default {
  data() {
    return {
      refereeCapacity: 0,
      agentCapacity: 0,
      racerCapacity: 0,
      capacity: 0,
      raminingCapacity:0,
      agentList: [
        {
          active: true,
          title: "علی صالحی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
        },
        {
          active: true,
          title: "عباس فخارسلیمانی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
        },
        {
          active: true,
          title: "عباس فخارسلیمانی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
        },
        {
          title: "حسین اوسطی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
        },
        {
          title: "حسین اوسطی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
        },
        {
          title: "حسین اوسطی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
        },
        {
          title: "حسین اوسطی",
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
        },
        {
          title: "سجاد جعفری",
          avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg"
        }
      ]
    };
  },
  components: {
    Header
  }
};
</script>

<style scoped>
.margin-top-40px {
  margin-top: 40px;
}
</style>
